import React from "react"
import { Avatar } from "@mui/material"
import { CustomIcon } from "components/icons"

import { FeatureListItem } from "components/domains/features"
import { ShopIcon } from "../../icons"

export const SearchListItem = ({ data, ...props }) => {
  const { primary, secondary, avatarProps } = data

  return (
    <FeatureListItem
      divider
      primary={primary}
      secondary={secondary}
      avatar={
        <Avatar src={avatarProps.src} variant="logo">
          {/* if there is no avatar, will fall back to categoryIconPath > ShopIcon */}
          {avatarProps.path ? (
            <CustomIcon path={avatarProps.path} />
          ) : (
            <ShopIcon />
          )}
        </Avatar>
      }
      //TODO: add Adornment prop
      {...props}
    />
  )
}
